/**
 * @desc The access-token getter the SocketBridge wires once, for clients that load later. The
 * admin live-update client (`automations-socket.ts`) only reaches admins, so it lives outside the
 * entry chunk (docs/code-splitting.md); the bridge publishes the getter here instead of importing
 * that client, and the client picks it up whenever it is first loaded.
 */
type TokenGetter = () => Promise<string>;

let current: TokenGetter | undefined;
const listeners = new Set<(getToken: TokenGetter) => void>();

/** @desc Publish the getter (the SocketBridge does, once). Every subscriber is told. */
export function setAccessTokenGetter(getToken: TokenGetter): void {
  current = getToken;
  for (const listener of listeners) listener(getToken);
}

/**
 * @desc Call `listener` with the getter now if it is already set, and again whenever it is set.
 * Returns the unsubscribe.
 */
export function onAccessTokenGetter(listener: (getToken: TokenGetter) => void): () => void {
  listeners.add(listener);
  if (current) listener(current);
  return () => {
    listeners.delete(listener);
  };
}
